import React from 'react';
import { Framework } from '@vfpf/framework';
import { initialModalState } from './state';
import { modalProcessCreator } from './process';
import { ModalDeps } from './deps';

export const ModalContext = Framework.createContext(initialModalState, modalProcessCreator);

export const useModalService = () => React.useContext(ModalContext);

export const ModalService: React.FC<React.PropsWithChildren> = props => {
  const deps: ModalDeps = {};
  const service = Framework.useService(deps, initialModalState, modalProcessCreator);

  return <ModalContext.Provider value={service}>{props.children}</ModalContext.Provider>;
};
